import type { ISessionCtx } from "../Session/SessionContext";

const isAuthenticated = (session: ISessionCtx["session"] | null | undefined): boolean => {
  if (!session) {
    return false;
  }

  return Boolean(session.info && session.user);
};

export default isAuthenticated;
